import { ImageThumbnailComponent, TagMolecule } from '@justomx/atlas-components'
import styled from 'styled-components'

const ImageWrapper = styled.div`
  position: relative;
  display: inline-block;
`

const OverlayTag = styled(TagMolecule)`
  position: absolute;
  top: -5px;
  left: -5px;
`

interface ImageMoleculeProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  size?: number
  radius?: number
  icon?: JSX.Element
  tagBg?: string
}

export const ImageMolecule = (props: ImageMoleculeProps) => {
  const { icon, tagBg, size = 24, radius = 8, ...imgProps } = props

  return (
    <ImageWrapper>
      {icon && (
        <OverlayTag
          shape="rounded"
          bgColor={tagBg}
          icon={icon}
          roundedSize={28}
        />
      )}
      <ImageThumbnailComponent
        size={size}
        {...imgProps}
        style={{ ...imgProps.style, borderRadius: `${radius}px` }}
      />
    </ImageWrapper>
  )
}
